// Copyright © 2021 Move Closer
import { AdBannerSize } from './AdBanner.contracts';
/**
 * Registry that binds the `AdBannerSize` with the applicable CSS class.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const adBannerSizeClassRegistry = {
    [AdBannerSize.MainContent]: '--size-main-content',
    [AdBannerSize.Teaser]: '--size-teaser',
    [AdBannerSize.TeaserVertical]: '--size-teaser-vertical',
    [AdBannerSize.TeaserList]: '--size-teaser-list',
    [AdBannerSize.MainIndex]: '--size-main-index',
    [AdBannerSize.InText]: '--size-in-text',
    [AdBannerSize.Medium]: '--size-medium',
    [AdBannerSize.HorizontalMobile]: '--size-horizontal-mobile',
    [AdBannerSize.Fullscreen]: '--size-fullscreen',
    [AdBannerSize.Sticky]: '--size-sticky',
    [AdBannerSize.StickyFixed]: '--size-sticky-fixed',
    [AdBannerSize.StickyTeaser]: '--size-sticky-teaser'
    // [AdBannerSize.StickyTop]: '--size-sticky-top'
};
/**
 * Registry that binds the `AdBannerSize` with the applicable creatives' dimensions.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const adBannerSizeCreativesDimensionsRegistry = {
    [AdBannerSize.MainContent]: [[300, 600]],
    [AdBannerSize.Teaser]: [[300, 180], [300, 100]],
    [AdBannerSize.TeaserVertical]: [[300, 250], [200, 200], [250, 250]],
    [AdBannerSize.TeaserList]: [[300, 60], [300, 50], [320, 50]],
    [AdBannerSize.MainIndex]: [[300, 600], [300, 250], [300, 300], [970, 250], [950, 200]],
    [AdBannerSize.InText]: [[300, 250], [750, 200]],
    [AdBannerSize.Medium]: [[300, 250], [300, 300]],
    [AdBannerSize.HorizontalMobile]: [[300, 50]],
    [AdBannerSize.Fullscreen]: [[300, 600], [580, 400]],
    [AdBannerSize.Sticky]: [],
    [AdBannerSize.StickyFixed]: [],
    [AdBannerSize.StickyTeaser]: []
    // [AdBannerSize.StickyTop]: []
};
/**
 * Values of tolerance for padding and with
 *
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
export const tolerances = {
    padding: 0.005,
    width: 5
};
